import { getIsFeatureToggleEnabled } from 'communicator/store/selectors';
import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { ParsedErrorResponse } from 'types/fetch';
import {
  CARD_ADD_FAILED,
  BILLING_ADDRESS,
  BILLING_ADDRESS_REQUIRED,
  ENROLL_FAILURE_MESSAGES,
  ENROLL_THE_USER,
  CARD_ALREADY_EXISTS,
  IDENTITY_VALIDATION_REQUIRED
} from './error-enum-reason';

//START GENAI@CHATGPT4
/**
 * Retrieves the checkout error message based on the response object.
 * @param response The parsed error response object.
 * @returns An object containing the reason and message of the checkout error.
 */
//END GENAI@CHATGPT4
export function getCheckoutErrorMessage(response: ParsedErrorResponse<OrchestratorErrorResponse>) {
  const errorDetails = {
    reason: CARD_ADD_FAILED,
    message: ENROLL_FAILURE_MESSAGES.CARD_ADD_FAILED
  };

  const { status, reason, message } = response.errorObject;
  const messageString = message.toUpperCase();

  //START GENAI@CHATGPT4
  if (
    status === 400 &&
    reason.toUpperCase() === 'BAD REQUEST' &&
    messageString.includes(BILLING_ADDRESS)
  ) {
    errorDetails.reason = BILLING_ADDRESS_REQUIRED;
    errorDetails.message = ENROLL_FAILURE_MESSAGES.BILLING_ADDRESS_REQUIRED;
    return errorDetails;
  }

  if (
    status === 409 &&
    reason.toUpperCase() === 'CONFLICT' &&
    messageString.includes(ENROLL_THE_USER)
  ) {
    errorDetails.reason = IDENTITY_VALIDATION_REQUIRED;
    errorDetails.message = ENROLL_FAILURE_MESSAGES.IDENTITY_VALIDATION_REQUIRED;
    return errorDetails;
  }
  //END GENAI@CHATGPT4

  if (
    getIsFeatureToggleEnabled('enableMobileAsId') &&
    status === 409 &&
    reason.toUpperCase() === 'CONFLICT' &&
    messageString.includes(CARD_ALREADY_EXISTS)
  ) {
    errorDetails.reason = CARD_ADD_FAILED;
    errorDetails.message = ENROLL_FAILURE_MESSAGES.CARD_ALREADY_EXISTS_ERROR;
    return errorDetails;
  }

  return errorDetails;
}
